import React from "react";


// <img src="/images/question-mark.svg" width="45" />; // 
export default function PageNot() {
  return (

    <div className="container mx-auto pt-12 px-6 md:pt-20 bg-white text-center h-screen">
      <h1 className="font-semibold text-3xl pt-20 mb-6">404 : Page Not Found</h1>
      <div className="flex justify-center">
        <img
          className="my-4 not-found-logo"
          src="/images/question-mark.svg"
          alt="not-found"
          width="110"
        />
      </div>
      <h1 className="text-3xl text-gray-600 m-6">The page you are looking for cannot be found.</h1>
      <h1 className="text-lg text-gray-600 m-4">You may have followed a bad link or incorrectly typed the URL.</h1>
      <h1 className="text-lg text-gray-600 m-2">Follow these popular links to find what you're looking for:</h1>
      <div>
        <p className="text-center text-purple-900 font-semibold">
          {' '}
          <a className="hover:underline visited:text-purple-600" href="/home" target="_self">
            Home
          </a>{' '}
          |{' '}
          <a className="hover:underline visited:text-purple-600" href="/account" target="_self">
            Account
          </a>{' '}
          |{' '}
          <a className="hover:underline visited:text-purple-600" href={'/glossary'} target="_self">
            Glossary
          </a>{' '}
        </p>
      </div>
      
    </div>
  );
}
